<template>
  <q-page>
    <div class="q-pt-md col-12">
      <section class="q-pr-md flex row justify-end">
        <span class="text-red"
          >Proxima atualização em: {{ temporizationRefresh }}</span
        >
      </section>
      <q-list
        bordered
        class="rounded-borders"
        v-for="item in listOsByContract"
        :key="item.osNumber"
      >
        <q-expansion-item
          expand-separator
          :header-style="{ backgroundColor: '#FFFFFF' }"
        >
          <template v-slot:header>
            <div class="row col-5 flex justify-center items-center">
              <div
                class="card-status-geral flex justify-center items-center text-center q-pa-sm"
                :class="'status-' + item.codeStatus"
              >
                <label>{{ item.statusOS }}</label>
              </div>
            </div>
            <div class="row col-5 q-ml-lg flex justify-center items-center">
              <div class="col-12 row flex justify-start">
                <label class="label-title-number-os">Nº da OS</label>
              </div>
              <div class="col-12 row flex justify-start">
                <label class="label-contract">
                  {{ item.osNumber }}
                </label>
              </div>
            </div>
          </template>
          <q-card>
            <q-card-section>
              <div class="content-card-datails-os">
                <div class="col-12 flex row">
                  <div class="col-6">
                    <div class="col-12">
                      <label class="label-title-content">Data</label>
                    </div>
                    <div class="col-12">
                      <label class="label-result-content">{{
                        item.initialDate
                      }}</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="col-12">
                      <label class="label-title-content">Cidade</label>
                    </div>
                    <div class="col-12">
                      <label class="label-result-content">{{
                        item.city
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 flex row q-mt-lg">
                  <div class="col-6">
                    <div class="col-12">
                      <label class="label-title-content">Hora de início</label>
                    </div>
                    <div class="col-12">
                      <label class="label-result-content">{{
                        item.initialTime
                      }}</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="col-12">
                      <label class="label-title-content"
                        >Hora de conclusão</label
                      >
                    </div>
                    <div class="col-12">
                      <label class="label-result-content">{{
                        item.conclusionTime
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 flex row q-mt-lg">
                  <div class="col-6">
                    <div class="col-12">
                      <label class="label-title-content">Hora de início</label>
                    </div>
                    <div class="col-12">
                      <label class="label-result-content">{{
                        item.initialTime
                      }}</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="col-12">
                      <label class="label-title-content"
                        >Tipo de OS</label
                      >
                    </div>
                    <div class="col-12">
                      <label class="label-result-content">{{
                        item.typeOSSelected
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 flex row q-mt-lg">
                  <div class="col-6">
                    <div class="col-12">
                      <label class="label-title-content"
                        >Tipo de atendimento</label
                      >
                    </div>
                    <div class="col-12">
                      <label class="label-result-content">{{
                        item.typeAttendance
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 flex row q-mt-lg">
                  <div class="col-6">
                    <div class="col-12">
                      <label class="label-title-content">Observação</label>
                    </div>
                    <div class="col-12">
                      <label class="label-result-content">{{
                        item.observation
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 flex row q-mt-lg">
                  <div class="col-6">
                    <div class="col-12">
                      <label class="label-title-content">Status Os</label>
                    </div>
                    <div class="col-12">
                      <label class="label-result-content">{{
                        item.descricao_error
                      }}</label>
                    </div>
                  </div>
                </div>
                <FromOsCall
                  v-if="istheSameDay(item)"
                  :serviceOsId="item.serviceId"
                  observation=""
                  @openOsCall="(osData) => openOsCall(osData)"
                />
              </div>
            </q-card-section>
          </q-card>
        </q-expansion-item>
      </q-list>
    </div>
  </q-page>
</template>

<script>
import FromOsCall from "@/components/RequestOsForms/FormOsCall";
import { date, useQuasar } from "quasar";
import ViewDatailsOsContractServices from "../services/ViewDatailsOsContractServices";

export default {
  name: "ViewListOsContractServiceHistory",
  components: {
    FromOsCall,
  },
  data() {
    const $q = useQuasar();

    return {
      $q,
      listOsByContract: [],
      temporizationRefresh: 15,
    };
  },
  created() {
    this.viewDatailsOsContractServices = new ViewDatailsOsContractServices();
  },

  methods: {
    getOsByContract() {
      this.viewDatailsOsContractServices
        .getOsByContract(this.$route.params.contract_number)
        .then((response) => {
          this.listOsByContract = response;
        })
        .catch((error) => {});
    },
    _refreshMethods() {
      setInterval(() => {
        this.getOsByContract();
        this.temporizationRefresh = 15;
      }, 15000);
    },
    _TemporizationRefresh() {
      setInterval(() => {
        this.temporizationRefresh -= 1;
      }, 1000);
    },
    openOsCall(osData) {
      this.viewDatailsOsContractServices
        .updatedOsStatus(osData)
        .then((response) => {
          this.$q.notify({
            message: "Chamado aberto com sucesso!",
            color: "red-9",
            position: "top",
            timeout: 3000,
          });
        })
        .catch((error) => {
          this.$q.notify({
            message: "Não foi possível abrir chamado!",
            color: "red-9",
            position: "top",
            timeout: 3000,
          });
        });
    },

    istheSameDay(item) {
      const today = new Date();
      const STATUS_CONCLUDED = [4, 20];
      const isRefazerDesob = item.codeTypeAttendance === 4;
      // && isRefazerDesob
      return (
       (item.initialDate == date.formatDate(today, "DD, MMMM, YYYY"))  && 
        STATUS_CONCLUDED.includes(item.codeStatus)
      );
    },
  },

  mounted() {
    this.getOsByContract();
    this._refreshMethods();
    this._TemporizationRefresh();
  },
};
</script>

<style scoped lang="scss">
label {
  font-family: Roboto;
  font-style: normal;
}

.card-status-geral {
  width: 100%;
  min-height: 5vh;

  label {
    font-weight: bold;
    font-size: 13px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.6);
  }
}
.status-1 {
  background-color: #caebed;
}
.status-2 {
  background-color: #e0e0e0;
}
.status-3 {
  background-color: #dcd3e4;
}
.status-4 {
  background-color: #e5f6e3;
}
.status-5 {
  background-color: #e5f6e3;
}
.status-7 {
  background-color: #e5f6e3;
}

.label-title-number-os {
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.label-contract {
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}

.label-title-content {
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.label-result-content {
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}

.q-card {
  background-color: transparent;
}
</style>